import React from 'react'
import { Box, Text } from '@workwhile/ui'

type ChartDatum = {
  name: string
}

type Props = {
  active?: boolean
  payload?: Array<{ payload?: ChartDatum; value?: number }>
}

export const ListingFunnelChartTooltip = ({ active, payload }: Props) => {
  if (!active || !payload?.length) {
    return null
  }

  const datum = payload[0]?.payload
  const users = payload[0]?.value

  if (!datum) {
    return null
  }

  return (
    <Box
      backgroundColor="white"
      border="1px solid"
      borderColor="neutrals.100"
      borderRadius="small"
      p={2}
    >
      <Text fontSize={2} fontWeight="600" mb={1}>
        {datum.name}
      </Text>
      <Text fontSize={2}>Users: {users}</Text>
    </Box>
  )
}
